import { IInstallment } from './Installment';
import { IBudgetPaymentMethod } from './PaymentMethod';

export default function getAllowedInstallments(
  method: IBudgetPaymentMethod,
): IInstallment[] {
  return method.installments.filter(
    installment => installment.allowed !== false,
  );
}
